import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, vShow as _vShow, mergeProps as _mergeProps, withCtx as _withCtx, createVNode as _createVNode, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock } from "vue"

import { deepCloneByJSON } from '@/utils/tools';
import { ref, watch, reactive, PropType } from 'vue'

// interface IProps {
//   modelValue: Object[] | string,
//   options: Object[],
//   labelKey?: string,
//   valueKey?: string,
//   showAllCheck?: boolean
// }
// const props = withDefaults(defineProps<IProps>(), {
//   modelValue: '',
//   options: [],
//   labelKey: '',
//   valueKey: '',
//   showAllCheck: false
// })

export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: {
  modelValue: {
    type: [String, Array],
    default: []
  },
  options: {
    type: Array as PropType<DefaultObjectType[]>,
    default: []
  },
  labelKey: {
    type: String,
    default: '',
  },
  valueKey: {
    type: String,
    default: ''
  },
  showAllCheck: {
    type: Boolean,
    default: true
  },
},
  emits: ['update:modelValue'],
  setup(__props, { emit }) {

const props = __props;

const cloneModelValue = ref([])



// 已选择的数据
const checked = reactive({
  data: []
})

const checkAll = ref(false)
const isIndeterminate = ref(true)

const getValue = (item: any) => {
  return props.valueKey ? item[props.valueKey] : item
}

const getLabel = (item: any) => {
  return props.labelKey ? item[props.labelKey] : item
}

const handleCheckAllChange = (val: any) => {
  let data = val ? props.options.reduce((p:any, c) => {
    p.push(getValue(c))
    return p
  }, []) : []
  // checked.data = data
  emit('update:modelValue', deepCloneByJSON(data))
  isIndeterminate.value = false
}
const handleChange = (value: any) => {
  const checkedCount = value.length
  checkAll.value = checkedCount === props.options.length
  isIndeterminate.value = checkedCount > 0 && checkedCount < props.options.length
  emit('update:modelValue', deepCloneByJSON(value))
}

// watch(() => checked.data, val => {
//   emit('update:modelValue', JSON.parse(JSON.stringify(val)))
// }, { immediate: true })

watch(() => props.modelValue, value => {
  //拷贝modelValue，防止报错
  cloneModelValue.value = deepCloneByJSON(props.modelValue)
  const checkedCount = value.length
  checkAll.value = checkedCount === props.options.length
  isIndeterminate.value = checkedCount > 0 && checkedCount < props.options.length
}, { immediate: true })


return (_ctx: any,_cache: any) => {
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_checkbox_group = _resolveComponent("el-checkbox-group")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _withDirectives(_createVNode(_component_el_checkbox, _mergeProps({
      modelValue: checkAll.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((checkAll).value = $event)),
      indeterminate: isIndeterminate.value,
      onChange: handleCheckAllChange
    }, _ctx.$attrs, { size: "large" }), {
      default: _withCtx(() => [
        _createTextVNode("Check all")
      ]),
      _: 1
    }, 16, ["modelValue", "indeterminate"]), [
      [_vShow, __props.showAllCheck]
    ]),
    _createVNode(_component_el_checkbox_group, {
      size: "large",
      modelValue: cloneModelValue.value,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((cloneModelValue).value = $event)),
      onChange: handleChange
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.options, (item) => {
          return (_openBlock(), _createBlock(_component_el_checkbox, {
            key: item,
            label: getValue(item),
            disabled: item.disabled
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(getLabel(item)), 1)
            ]),
            _: 2
          }, 1032, ["label", "disabled"]))
        }), 128))
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}
}

})